import ShadowFrame from './shadow-frame';
export default ShadowFrame;